interface Props {
  value: unknown;
  /** Optional summary label; defaults to "Raw JSON". */
  label?: string;
}

/** Collapsible pretty-printed JSON dump — lets QA inspect fields the screen doesn't surface. */
export function RawJson({ value, label = "Raw JSON" }: Props) {
  return (
    <details className="qa-raw">
      <summary>{label}</summary>
      <pre className="qa-json">{JSON.stringify(value, null, 2)}</pre>
    </details>
  );
}
